// removed by extract-text-webpack-plugin
module.exports = {"module":"module__3ssFf","moduleHeader":"moduleHeader__1U9RY","headerIcon":"headerIcon__1X1sR","headerText":"headerText__2DIag","moduleContent":"moduleContent__2meQI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Module/index.css
// module id = 1367
// module chunks = 0